module.exports = __webpack_public_path__ + "labioplastika_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_2_after_tn.jpg
// module id = 1537
// module chunks = 0